import type { SizeLocales } from "@lib/constants/filtersConstants";
import type { TCountryCode, TLanguageCode } from "countries-list";

export type CountryCode = TCountryCode;
export type LanguageCode = TLanguageCode;

export enum Market {
    MY = "my",
    SG = "sg",
    ES = "es",
    EE = "ee",
    IN = "in",
    KR = "kr",
    CA = "ca",
    US = "us",
    AU = "au",
    JP = "jp",
    GB = "gb",
    PL = "pl",
    PT = "pt",
    HU = "hu",
    CZ = "cz",
    HR = "hr",
    BE = "be",
    SI = "si",
    SK = "sk",
    FR = "fr",
    AT = "at",
    CH = "ch",
    DE = "de",
    NL = "nl",
    DK = "dk",
    FI = "fi",
    IE = "ie",
    LT = "lt",
    LV = "lv",
    NO = "no",
    SE = "se",
}

export interface SiteConfigEntry {
    country: CountryCode;
    countryName: string;
    language: LanguageCode[];
    currency: string;
    fractionDigits: number;
    roundingUnit?: number;
    shoeSizingConventions: SizeLocales[];
    sizeGuideCollections: SizeLocales[];
    checkout: {
        countryCode: string;
        requiresSalesTaxEstimation?: boolean;
        hasShippingFees?: boolean;
        hasShippingDetails?: boolean;
        minAddressLookupLength?: number;
        hasDHLExtraFields?: boolean;
        parcelShops?: {
            searchMethod: "address" | "latlng";
        };
    };
    geo: {
        centerLat: number;
        centerLng: number;
        swLat: number;
        swLng: number;
        neLat: number;
        neLng: number;
        initZoomLevel?: number;
        imperialMetricSystem?: boolean;
    };
    orderNumberFormatRegex?: RegExp;
    reCaptchaIntegration: {
        contactForm: boolean;
        checkout: boolean;
        signupForm: boolean;
    };
    liveChat?: boolean;
    hasTryAndBuy?: boolean;
    smartBanner?: {
        iOSAppId: string;
        googleAppId: string;
    };
    isCountryChangeForBillingAddressAllowed?: boolean;
    isOrderHistoryRoutesAllowed?: boolean;
    isGiftWrappingAllowed?: boolean;
    isProductInfoRequired?: boolean;
    showPriceLegalText?: boolean;
    amazonPay?: {
        enabled: boolean;
        bannerEnabled: boolean;
        merchantId: string;
        region: string;
        // This is dependant on the region
        checkoutJsUrl: string;
    };
    supportsGlobalPrivacyControl?: boolean;
    isMarketWithLoyalty?: boolean;
    onKlarnaSiteMessaging?: boolean;
    isOmnibusMarket?: boolean;
    HasPreviousSalesPrice?: boolean;
    trustpilotIntegration?: boolean;
    hasExtendedNewsletterForm?: boolean;
    hasTrueFit?: boolean;
    showParcelLockerId?: boolean;
    hideParcelLockerWorkingHours?: boolean;
    hideAvailabilityInStore?: boolean;
    hasRaffle?: boolean;
    hasNotifySizeAvailability?: boolean;
    hasExpressCheckout?: boolean;
    hasGrabPayWidget?: boolean;
    externalScripts?: {
        attentive?: boolean;
    };
    promotionalThemeColor?: string;
}
